import '@angular/compiler';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment, setApiHost } from './environments/environment';

/**
 * Reads the API URL injected at container startup (Coolify env var ->
 * docker-entrypoint.sh -> assets/env-config.json, generated via envsubst —
 * see Dockerfile) and overrides the build-time default in environment.ts.
 *
 * Must resolve BEFORE `bootstrapModule` so every service (constructed as
 * part of module instantiation, ahead of APP_INITIALIZER) already sees the
 * correct API_PATH. Missing file / empty apiUrl (e.g. local `ng serve`,
 * or a container started without the env var) silently keeps the
 * build-time default.
 */
async function loadRuntimeApiUrl(): Promise<void> {
  try {
    const response = await fetch(`env-config.json?_=${Date.now()}`, { cache: 'no-store' });
    if (!response.ok) {
      return;
    }
    const config = await response.json();
    if (config?.apiUrl) {
      setApiHost(config.apiUrl);
    }
  } catch {
    // No runtime config available — keep the build-time default.
  }
}

loadRuntimeApiUrl().then(() => {
  if (environment.production) {
    enableProdMode();
  }

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
});
